export default __webpack_public_path__ + "static/media/RAPPORT GENERAL ANNUEL DES ACTIVITES 2024.56ed879e.pdf";